import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/provide/common.service';
import { DeliveryOptionsService } from 'src/app/provide/delivery-options.service';
import { Subscription } from 'rxjs';


declare var $;
@Component({
  selector: 'mycart-layout',
  templateUrl: './mycart-layout.component.html',
  styleUrls: ['./mycart-layout.component.scss'],
  standalone: false,
})
export class MycartLayoutComponent implements OnInit, OnDestroy {
  @Input() cartListDetails: any;
  @Input() payOutDetail: any;
  @Input() optionList: any;

  @Output() onRemoveItem = new EventEmitter();
  // @Output() navigateToaddress = new EventEmitter
  @Output() navigateToaddress = new EventEmitter<{
    deliveryMode: string;
    weight: string;
    volume: string;
  }>();

  @Output() onUpdateCartValue = new EventEmitter();
  @Output() payOutEvent = new EventEmitter();

  sum: any = 0;
  grandTotal: any = 0;
  subtotal: any;
  discountPercent: any;
  discount: any;
  flag: boolean = true;
  loadingButton: any = [];
  inputValue: number;

  cryptoBalance: any;
  availableTokenToUse: number = 0;
  private subscriptions: Subscription[] = [];

  constructor(
    public commonService: CommonService, 
    private router: Router, 
    private cdr: ChangeDetectorRef,
    private deliveryOptionsService: DeliveryOptionsService
  ) {}

  ngOnInit(): void {
    this.getCartList();
    
    // Subscribe to crypto balance
    const cryptoBalanceSub = this.commonService.cryptoBalance.subscribe((ele) => {
      this.cryptoBalance = ele;
      let grandTotal = this.payOutDetail.totalAmount
        ? this.payOutDetail.totalAmount + this.payOutDetail.deliveryFee
        : 0;
      let availableToken = Number(this.cryptoBalance.available);
      if (grandTotal >= 100) {
        this.availableTokenToUse = availableToken >= 10 ? 10 : availableToken;
      }
    });
    this.subscriptions.push(cryptoBalanceSub);

    // Subscribe to delivery option changes from service (for synchronization with cart-drawer)
    const deliveryOptionSub = this.deliveryOptionsService.deliveryOption$.subscribe(option => {
      if (option && this.payOutDetail) {
        // Update delivery option when changed from cart-drawer
        this.deliveryOption = option;
        this.payOutDetail.deliveryFee = option.deliveryAmount || 0;
        this.payOutDetail.deliveryMode = option.deliveryType;
        this.payOutDetail.weight = option.weight;
        this.payOutDetail.volume = option.volume;
        
        // Recalculate total
        const total = this.calculateTotal();
        this.payOutDetail.totalAmount = total + (option.deliveryAmount || 0);
        
        // Update localStorage
        localStorage.setItem('payOutDetail', JSON.stringify(this.payOutDetail));
        
        // Trigger change detection
        this.cdr.detectChanges();
      }
    });
    this.subscriptions.push(deliveryOptionSub);

    // Share optionList with service if available
    if (this.optionList && this.optionList.length > 0) {
      this.deliveryOptionsService.setOptionList(this.optionList);
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  getAddedDate(createdAt: string, days: number) {
    let date = new Date(createdAt).setDate(new Date(createdAt).getDate() + 7);
    return date;
  }

  getSundayDate(inputDate) {
    // Create a new Date object from the input date
    const currentDate = new Date();

    // Get the current day of the week (0 = Sunday, 1 = Monday, ..., 6 = Saturday)
    const currentDayOfWeek = currentDate.getDay();

    // Calculate the number of days until the next Sunday
    const daysUntilNextSunday = 7 - currentDayOfWeek;

    // Create a new Date object for the next Sunday
    const nextSunday = new Date(currentDate);
    nextSunday.setDate(currentDate.getDate() + daysUntilNextSunday);

    // Format the date as a string (e.g., "YYYY-MM-DD")
    const nextSundayDate = nextSunday.toISOString().split('T')[0];

    return nextSundayDate;
  }

  getNextSaturdayFromDate(inputDate) {
    // Create a new Date object from the input date
    const currentDate = new Date();

    // Get the current day of the week (0 = Sunday, 1 = Monday, ..., 6 = Saturday)
    const currentDayOfWeek = currentDate.getDay();

    // Calculate the number of days until the next Saturday
    const daysUntilNextSaturday = 6 - currentDayOfWeek + 7;

    // Create a new Date object for the next Saturday
    const nextSaturday = new Date(currentDate);
    nextSaturday.setDate(currentDate.getDate() + daysUntilNextSaturday);

    // Format the date as a string (e.g., "YYYY-MM-DD")
    const nextSaturdayDate = nextSaturday.toISOString().split('T')[0];

    return nextSaturdayDate;
  }

  getNextBusinessDayFromDate(inputDate) {
    // Create a new Date object from the input date
    const currentDate = new Date();

    // Calculate the next day of the week
    const nextDay = new Date(currentDate);
    nextDay.setDate(currentDate.getDate() + 1);

    // Check if the next day is a weekend (Saturday or Sunday)
    if (nextDay.getDay() === 0) {
      // If it's Sunday, add 2 days to get to the next business day (Monday)
      nextDay.setDate(nextDay.getDate() + 2);
    } else if (nextDay.getDay() === 6) {
      // If it's Saturday, add 1 day to get to the next business day (Monday)
      nextDay.setDate(nextDay.getDate() + 1);
    }

    // Format the date as a string (e.g., "YYYY-MM-DD")
    const nextBusinessDay = nextDay.toISOString().split('T')[0];

    return nextBusinessDay;
  }

  getNextDayOrSameDay(inputDate) {
    // Create a new Date object from the input date
    const currentDate = new Date();

    // Get the current hour of the day (0-23)
    const currentHour = currentDate.getHours();

    // Check if the current hour is less than 17 (5 PM in 24-hour format)
    if (currentHour < 17) {
      // If it's before 5 PM, return the same day
      return currentDate.toISOString().split('T')[0];
    } else {
      // If it's 5 PM or later, return the next day
      const nextDay = new Date(currentDate);
      nextDay.setDate(currentDate.getDate() + 1);
      return nextDay.toISOString().split('T')[0];
    }
  }
  removeCartList(e) {
    this.onRemoveItem.emit(e);
  }
  erorMessageArr: any = [];
  localQuantity: any = [];

  updateCartValue(id, prizeSize, avlQty, currentqty?, ind?, total?) {
    const availableQuantity = Number(total) || 0;
    const requestedQuantity = Number(avlQty);
    
    // Validate and clamp quantity to available stock
    if (requestedQuantity > availableQuantity) {
      this.erorMessageArr[ind] = `You cannot add more than available quantity.`;
      setTimeout(() => {
        this.erorMessageArr[ind] = '';
      }, 3000);
      // Reset to available quantity if exceeded
      if (typeof ind === 'number' && this.cartListDetails && this.cartListDetails[ind]) {
        this.cartListDetails[ind].quantity = availableQuantity;
      }
      return;
    }

    // Ensure quantity is at least 1
    if (requestedQuantity < 1) {
      if (typeof ind === 'number' && this.cartListDetails && this.cartListDetails[ind]) {
        this.cartListDetails[ind].quantity = 1;
      }
      return;
    }

    // Clear any previous error messages
    this.erorMessageArr[ind] = '';

    let obj = {
      id: id,
      prizeSize: prizeSize,
      avlQty: requestedQuantity,
    };
    
    this.inputValue = requestedQuantity;

    // Update local quantity immediately so UI reflects changes without waiting for parent refresh
    if (typeof ind === 'number' && this.cartListDetails && this.cartListDetails[ind]) {
      this.cartListDetails[ind].quantity = requestedQuantity;
    }

    this.loadingButton[ind] = true;

    setTimeout(() => {
      this.loadingButton[ind] = false;
    }, 1000);

    this.onUpdateCartValue.emit(obj);
    this.localQuantity[ind] = requestedQuantity;
  }

  getDeliveryName(e) {
    let deliveryOption =
      e == 'SUNDAY'
        ? 'Sunday'
        : e == 'SAMEDAY'
        ? 'Sameday'
        : e == 'BUSINESSDAY'
        ? 'Next business day'
        : e == 'SATURDAY'
        ? 'Saturday'
        : 'Standard';

    return deliveryOption;
  }

  getPrice(e: any) {
    return this.commonService.getPrice(e);
  }

  getActualPrice(e) {
    let pricesizeId = e.priceSizeDetails.id;
    let product = e.productId.priceSizeDetails.find((ele) => {
      return ele.id == pricesizeId;
    });

    return 'price' in product ? product.price : 0;
  }
  getDiscount(e) {
    let pricesizeId = e.priceSizeDetails.id;
    let product = e.productId.priceSizeDetails.find((ele) => {
      return ele.id == pricesizeId;
    });
    let actualPrice = Number(product.price);
    let discountedPrice = Number(e.totalPrice);

    let discounted = Number(
      ((actualPrice - discountedPrice) / actualPrice) * 100
    ).toFixed(0);

    return discounted;
  }

  navigateToaddresss() {
    // this.flag = false
    // this.payOutDetail = JSON.parse(localStorage.getItem('payOutDetail'))
    // this.navigateToaddress.emit({deliveryMode : this.payOutDetail.deliveryMode, weight: this.payOutDetail.weight, volume: this.payOutDetail.volume})
    const storedDetail = localStorage.getItem('payOutDetail');
    if (storedDetail) {
      this.payOutDetail = JSON.parse(storedDetail);
      this.navigateToaddress.emit({
        deliveryMode: this.payOutDetail.deliveryMode,
        weight: this.payOutDetail.weight,
        volume: this.payOutDetail.volume,
      });
    } else {
      this.commonService.errorToast('Please select delivery option first.');
      console.error('No payOutDetail found in localStorage');
    }
  }

  getCartList(e?) {
    //  console.log(e);

    this.sum = 0;
    this.grandTotal = 0;
    this.cartListDetails = e || this.cartListDetails;
    for (const item of this.cartListDetails) {
      this.sum += this.getActualPrice(item) * item.quantity;
      if (item.isDealActive) {
        this.grandTotal += item.dealPrice * item.quantity;
      } else {
        this.grandTotal += item.priceSizeDetails.price * item.quantity;
      }
    }

    this.discount = this.sum - this.grandTotal;
    this.discountPercent = Number(
      ((this.sum - this.grandTotal) / this.grandTotal) * 100
    ).toFixed(2);
  }
  openDeliveryModal() {
    $('#modalDeliveryConfirmation').modal('show');
  }

  deliveryOption: any;
  onSelectDeliveryOption(e) {
    this.deliveryOption = e;
  }
  onConFirm() {
    if (!this.payOutDetail) {
      this.commonService.errorToast('Payment details not available. Please refresh the page.');
      return;
    }

    // If deliveryOption is not set, check if there's already a selected delivery mode
    if (!this.deliveryOption) {
      if (this.payOutDetail.deliveryMode && this.optionList && this.optionList.length > 0) {
        // Find the matching option from optionList based on deliveryMode
        const matchedOption = this.optionList.find(
          (option) => option.deliveryType === this.payOutDetail.deliveryMode
        );
        if (matchedOption) {
          this.deliveryOption = matchedOption;
        } else {
          this.commonService.errorToast('Please select a delivery option.');
          return;
        }
      } else {
        this.commonService.errorToast('Please select a delivery option.');
        return;
      }
    }

    this.payOutDetail.deliveryFee = this.deliveryOption.deliveryAmount || 0;
    this.payOutDetail.deliveryMode = this.deliveryOption.deliveryType;
    this.payOutDetail.weight = this.deliveryOption.weight;
    this.payOutDetail.volume = this.deliveryOption.volume;

    // Recalculate totalAmount with the new delivery fee
    const total = this.calculateTotal();
    this.payOutDetail.totalAmount = total + (this.payOutDetail.deliveryFee || 0);

    localStorage.setItem('payOutDetail', JSON.stringify(this.payOutDetail));

    // Update service to sync with cart-drawer
    this.deliveryOptionsService.setDeliveryOption(this.deliveryOption);

    // Trigger change detection to update UI immediately
    this.cdr.detectChanges();

    // Close modal programmatically after successful confirmation
    $('#modalDeliveryConfirmation').modal('hide');

    this.payOutEvent.emit({
      deliveryMode: this.payOutDetail.deliveryMode,
      weight: this.payOutDetail.weight,
      volume: this.payOutDetail.volume,
    });
  }

  clearAllItems() {
    if (this.cartListDetails && this.cartListDetails.length > 0) {
      if (confirm('Are you sure you want to clear all items from your cart?')) {
        this.cartListDetails.forEach(item => {
          this.removeCartList(item._id);
        });
      }
    }
  }

  continueShopping() {
    // Navigate back to products/home page
    window.history.back();
  }

  navigateToProduct(productId: string) {
    if (productId) {
      this.router.navigate(['/customer-category-particular-view'], {
        queryParams: { _id: productId }
      });
    }
  }

  getTotalItemCount(): number {
    if (!this.cartListDetails || this.cartListDetails.length === 0) {
      return 0;
    }
    return this.cartListDetails.reduce((total, item) => total + (item.quantity || 0), 0);
  }

  // Calculate Subtotal: Sum of (Each Price × Quantity) for all cart items
  calculateSubtotal(): number {
    if (!this.cartListDetails || this.cartListDetails.length === 0) {
      return 0;
    }
    return this.cartListDetails.reduce((total, item) => {
      const unitPrice = this.getActualPrice(item);
      return total + (unitPrice * (item.quantity || 0));
    }, 0);
  }

  // Calculate the actual amount being charged (after deals/discounts)
  calculateChargedAmount(): number {
    if (!this.cartListDetails || this.cartListDetails.length === 0) {
      return 0;
    }
    return this.cartListDetails.reduce((total, item) => {
      let itemPrice = 0;
      if (item.isDealActive && item.dealPrice) {
        itemPrice = item.dealPrice;
      } else if (item.priceSizeDetails && item.priceSizeDetails.price) {
        itemPrice = item.priceSizeDetails.price;
      } else if (item.totalPrice) {
        itemPrice = item.totalPrice;
      }
      return total + (itemPrice * (item.quantity || 0));
    }, 0);
  }

  // Calculate Discount: Subtotal - Charged Amount
  calculateDiscount(): number {
    const subtotal = this.calculateSubtotal();
    const chargedAmount = this.calculateChargedAmount();
    const discount = subtotal - chargedAmount;
    return discount > 0 ? discount : 0;
  }

  // Calculate Total: Subtotal - Discount
  calculateTotal(): number {
    const subtotal = this.calculateSubtotal();
    const discount = this.calculateDiscount();
    return subtotal - discount;
  }

  // Get Shipping Charge
  getShippingCharge(): number {
    return (this.payOutDetail && this.payOutDetail.deliveryFee) ? this.payOutDetail.deliveryFee : 0;
  }

  // Calculate Grand Total: Total + Shipping Charge
  calculateGrandTotal(): number {
    const total = this.calculateTotal();
    const shipping = this.getShippingCharge();
    return total + shipping;
  }
}
